import { render, staticRenderFns } from "./ProblemListDialog.vue?vue&type=template&id=29ca381a&"
import script from "./ProblemListDialog.vue?vue&type=script&lang=ts&"
export * from "./ProblemListDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports